const depotConstants = {
  GET_DEPOTS: "GET_DEPOTS",
  GET_DEPOTS_SUCCESS: "GET_DEPOTS_SUCCESS",
  GET_DEPOTS_FAILURE: "GET_DEPOTS_FAILURE",
}

export default depotConstants;
